import { MessageService } from 'primeng/api';
import { Component, OnInit,EventEmitter, Output} from '@angular/core';
import { LoginCredentials } from 'src/app/models/LoginCredentials';
import { Subscription } from 'rxjs';
import { NavigationExtras, Router, ActivatedRoute } from '@angular/router';
import { AuthentificationService } from 'src/app/services/auth/authentification.service';
import { LoginErrorsModel } from 'src/app/models/LoginErrors/LoginErrors';
import { UserNotFound } from 'src/app/models/LoginErrors/UserNotFound';
import { BaseLoginError } from 'src/app/models/LoginErrors/BaseLoginError';
import { UserLocked } from 'src/app/models/LoginErrors/UserLocked';
import { UserInactive } from 'src/app/models/LoginErrors/UserInactive';
import { TranslateService } from '@ngx-translate/core';
import { UserDesactivated } from 'src/app/models/LoginErrors/userDesactivated';
import { PopupsInfo } from '../../tools/page-login-popups/models/popups-info.model';
import { pageLoginService } from 'src/app/services/page-login/page-login.service';
import { PopupType } from '../../tools/page-login-popups/models/popupType.model';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import {UserBlockedNoActiveContract} from "../../../models/LoginErrors/UserBlockedNoActiveContract";
import { footerService } from 'src/app/services/footer.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ConfigurationService } from 'src/app/services/configuration.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    providers: [MessageService]
})

export class LoginComponent implements OnInit{
    errorToken: boolean;
	display_dialog_info :boolean=false;
    submitted: boolean;
    copyrightHtml: string = "";
    dialogInfoHtml: string = "";
    loginInfoHtml: string = "";
    pageLogin : any
    imageSrc: string;
    isVisible : boolean = false;
    colorCode: string;
    popupsInfo: PopupsInfo;
    popupsFirstConnection: PopupsInfo;
    popupType = PopupType.LOGIN_With_FIRST_CONNECTION
    isManager = environment['MANAGER_TYPE'];
    appVersion: string;
    currentYear: number = new Date().getFullYear();
    safeHtml: SafeHtml;
    @Output() closed: EventEmitter<boolean> = new EventEmitter<boolean>();
    hidePremConxProcess = this.configurationService.get().hidePremConxProcess;

    constructor(private authentificationService: AuthentificationService, private router : Router, private readonly translate : TranslateService,
        private activatedRoute:ActivatedRoute, private messageService:MessageService,
        private pageLoginService: pageLoginService, private cookieService: CookieService, private footerService: footerService ,private sanitizer: DomSanitizer, private configurationService: ConfigurationService) {
        const navigation = this.router.getCurrentNavigation();
        const state = navigation.extras.state as {identifiant: string};
        this.credentials.username = state?.identifiant;
        state?.identifiant ? setTimeout(() => {
            this.messageService.add({key: 'SUCCESS_ACTIVATION_ACCOUNT',severity:'success', summary: 'Activation réussie', detail: 'Votre compte est maintenant activé'});
        }, 50) : null;
        const errorState = navigation.extras.state as {errorToken: boolean};
        errorState?.errorToken==true ? setTimeout(() => {
            this.messageService.add({key: 'ERROR_TOKEN',severity:'error', summary: 'Une erreur est survenue', detail: 'Veuillez réessayer'});
        }, 50) : null;
    }

    credentials = new LoginCredentials();
    loginErrors: any;
    loading = false;
    display_premiere_connexion : boolean = false;



    ngOnInit() {
        // this.credentials.username = '013374400';
        // this.credentials.password = 'Abc1234567+';
        this.messageService.add({ key: 'tokenError', severity: 'error', summary: 'Error', detail: 'Token invalide' })
        // this.credentials.username = '013374400';
        // this.credentials.password = 'Abc1234567+';
        this.loadWordingCopyright();
        this.loadWordingDialogPremiereConnexion();
        this.loadWordingLoginInfo();
        this.loadAppVersion();
        // Vérification des paramètres de l'URL
        this.activatedRoute.queryParams.subscribe(params => {
            const status = params['Status'];
            if (status === 'SIGNED') {
                this.messageService.add({
                    key: 'adhesion',
                    severity: 'success',
                    summary: this.translate.instant('login.succes-adhesion-summary'),
                    detail: this.translate.instant('login.succes-adhesion-detail')
                });
            }
        });
      }

      loadWordingCopyright() {
        this.translate.get('login.copyright').subscribe((value: string) => {
            this.copyrightHtml = value;
        });
    }

    loadWordingDialogPremiereConnexion() {
        this.translate.get('login.dialogInfo_text').subscribe((value: string) => {
            this.dialogInfoHtml = value;
        });
    }

    loadWordingLoginInfo() {
        this.translate.get('login.info').subscribe((value: string) => {
            this.loginInfoHtml = value;
        });
    }


    authenticate() {
        this.submitted=true
        this.resetLoginErrors();
        if (this.credentials.password && this.credentials.username) {
            this.submitted=false
            this.loading = true;
            var authentificateSubscription = this.authentificationService.authenticate(this.credentials).subscribe({
                next: (data) => {
                    if (data instanceof BaseLoginError) {
                        this.loginErrors = data;
                    } else {
                        this.authentificationService.processSuccessfulAuthentication(data);
                    }
                    this.unsubscribe(authentificateSubscription);
                    this.loading = false;
                }
            });
        } else {
            this.submitted=true
        }
    }

    unsubscribe(subscription: Subscription) {
        subscription.unsubscribe();
    }
    showInfo(): boolean {
        return this.display_dialog_info = true;
    }
    premiereConnexion() {
            this.pageLoginService.getPageLoginPopups(PopupType.FIRST_CONNECTION).subscribe({
                next: (data) => {
                    this.getPopupFirstConnection(data);
                    this.display_premiere_connexion = true;
                },
                error: () => {
                    this.display_premiere_connexion = true;
                }
            });

    }
    navigateToPremiereConnexion(identifiant: boolean) {
        const navigationExtras: NavigationExtras = { state: { identifiant: identifiant }};
        this.router.navigate(['/auth/premiere_connexion'], navigationExtras);
    }

    resetLoginErrors() {
        this.submitted=false;
        this.loginErrors = new LoginErrorsModel();

    }


    isUserLocked() {
        return this.loginErrors instanceof UserLocked && this.loginErrors.isShow;
    }

    isUserInactive() {
        return this.loginErrors instanceof UserInactive && this.loginErrors.isShow;
    }

    isUserNotFound() {
        return this.loginErrors instanceof UserNotFound && this.loginErrors.isShow;
    }

    isUserDesactivated() {
        return this.loginErrors instanceof UserDesactivated && this.loginErrors.isShow;
    }

  isUserBlockedNoActiveContract() {
    return this.loginErrors instanceof UserBlockedNoActiveContract && this.loginErrors.isShow;
  }

    dialogInfoClose(e){
        this.display_dialog_info=!e;
    }
    getPopupInfo(popupInfo) {
        this.popupsInfo = popupInfo
    }
    getPopupFirstConnection(popupFirstConnection) {
        this.popupsFirstConnection = popupFirstConnection
        this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.popupsFirstConnection?.content);
    }

    get subSiteName() {
        return (environment as any)?.SUB_SITE_NAME;
    }

    loadAppVersion() {
    this.footerService.getAppVersion().subscribe(
      version => {
        this.appVersion = 'V ' + version;
      },
    );
    }
    closeDialog(){
        this.closed.emit(true);
    }
    }
